module.exports = __webpack_public_path__ + "static/music-republicain-3-d0de25111bf0ae4071e2ce72c95fe5d9.jpg";